import { render, staticRenderFns } from "./suModel.vue?vue&type=template&id=23b0a811&scoped=true&"
import script from "./suModel.vue?vue&type=script&lang=js&"
export * from "./suModel.vue?vue&type=script&lang=js&"
import style0 from "./suModel.vue?vue&type=style&index=0&id=23b0a811&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b0a811",
  null
  
)

export default component.exports